import './Toggle.scss'

import classNames from 'classnames'
import React, { HTMLAttributes, HTMLProps } from 'react'

export interface ToggleProps extends HTMLAttributes<HTMLLabelElement> {
  className?: string
  inputProps: HTMLProps<HTMLInputElement>
}

export default function Toggle(props: ToggleProps) {
  const { className, inputProps, ...otherProps } = props
  const mergedClassName = classNames('toggle', className)

  return (
    <label className={mergedClassName} {...otherProps}>
      <input type="checkbox" {...inputProps} />
      <span className="toggle__slider" />
    </label>
  )
}
